function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import $9UXlH$intlmessageformat from "intl-messageformat";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $972eb555d604f491$export$526ebc05ff964723 = /*#__PURE__*/function () {
  function $972eb555d604f491$export$526ebc05ff964723(locale, messages) {
    _classCallCheck(this, $972eb555d604f491$export$526ebc05ff964723);
    this.locale = locale;
    this.messages = messages;
    this.cache = {};
  }
  return _createClass($972eb555d604f491$export$526ebc05ff964723, [{
    key: "format",
    value: function format(key, variables) {
      var message = this.cache[key];
      if (!message) {
        var msg = this.messages.getStringForLocale(key, this.locale);
        if (!msg) throw new Error("Could not find intl message ".concat(key, " in ").concat(this.locale, " locale"));
        message = new (0, $9UXlH$intlmessageformat)(msg, this.locale);
        this.cache[key] = message;
      }
      var varCopy;
      if (variables) varCopy = Object.keys(variables).reduce(function (acc, key) {
        acc[key] = variables[key] == null ? false : variables[key];
        return acc;
      }, {});
      return message.format(varCopy);
    }
  }]);
}();
export { $972eb555d604f491$export$526ebc05ff964723 as MessageFormatter };